import React, { useEffect, useState } from "react";
import { Button, Dropdown, Flex, Menu, Drawer, Tooltip, Popconfirm } from "antd";
import {
  LogoutOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import CustomAvatar from "../../../Components/CustomAvatar";
import UserStatusBadge from "../../../Components/UserStatusBadge";
import EmojiIcon from "../../../assets/icons/Emoji";
import {setProfileFlag } from "../../../store";
import { useNavigate } from "react-router";
// import { useSocket } from "../../../Context/SocketContext";
import ApiService from "../../../API/apiService";
import { API_ENDPOINTS } from "../../../API/endpoints";
import { handleApiError } from "../../../utils/CommonFunctions";
import CustomStatusModal from "./CustomStatusModal";
import { useUserSelfStore } from "../../../store/apis/useUserStore";
import { useSocket } from "../../../Context/SocketContext";

import { InfoCircleIcon } from "../../../assets/icons";
import { useSocketEvents } from "../../../socket/hooks/useSocketEvents";
import { clearSharedSso } from "../../../utils/ssoCookie";
const ProfileMenu = ({socket}) => {
    const { emit,disconnect } = useSocketEvents();
  
  const [openProfileSidebarMenu, setOpenProfileSidebarMenu] = useState(false);
  const [profileMenuPlacement] = useState("right");
  const [isSetCustomStatusModalOpen, setIsSetCustomStatusModalOpen] = useState(false);
  const [userDetails, setUserDetails] = useState({});

  const UserData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : "";
  const userSelfData = useUserSelfStore((state) => state.userSelfData);
  const getUserSelfDetails = useUserSelfStore((store) => store.getUserSelfDetails);


  

  const navigate = useNavigate();
  // const socket = useSocket();

  
  const showProfileSidebarMenu = () => {
    setOpenProfileSidebarMenu(true);
  };


  const onClose = () => {
    setOpenProfileSidebarMenu(false);
  };

  const showProfileModal = () => {
    setProfileFlag(true);
    setOpenProfileSidebarMenu(false);
  };

  const showSetCustomStatusModal = (e) => {
    e.stopPropagation();
    setOpenProfileSidebarMenu(false);
    setIsSetCustomStatusModalOpen(true);
  };

  const clearCustomStatus = async (e) => {
    e.stopPropagation();
    const reqBody = {
      customStatus: "",
      customStatusEmoji: "",
      user_id: userSelfData._id,
      is_custom_status: true,
      
    };
    try {
      const response = await ApiService.post(
        API_ENDPOINTS.updateUserDetails,
        reqBody
      );
      
      if (response?.data && response?.statusCode === 200) {
        let locadata=JSON.parse(localStorage.getItem("userData") || "{}");

        const updatedUserDetails = {
          ...locadata,
          customStatus: "",
          customStatusEmoji: "",
        };
        
        // setUserDetails(updatedUserDetails); 
        localStorage.setItem("userData", JSON.stringify(updatedUserDetails));
        getUserSelfDetails(updatedUserDetails._id);
      }
    } catch (error) {
      handleApiError(error, "Error while clearing custom status");
    }
  };

  const handleChangeCustomStatusModal = (value)=>setIsSetCustomStatusModalOpen(value);
  const handleUserDetailsUpdate = (data) =>  getUserSelfDetails(data._id);;

  const logOut = () => {
    // setUserDetails({});
    const companySlug = localStorage.getItem("companySlug") || "default"; // <-- Move here
    console.log("companySlug", companySlug);
    // if(companySlug !=="undefined"){
    //   navigate(`/${companySlug}/login`);

    // }
    // else{
    navigate("/");
    // }
    // Clear the shared SSO cookie first so sibling apps single-logout too.
    clearSharedSso();
    localStorage.clear();
    // disconnect();
    // socket.disconnect();
  };



  
//   const handlestatus = (newStatus) => {
//   const updatedUserDetails = { ...userDetails, status: newStatus };
//   setUserDetails(updatedUserDetails); // Update global state
//   getUserSelfDetails(updatedUserDetails._id);
//   localStorage.setItem("userData", JSON.stringify(updatedUserDetails)); // Persist changes
// };
const handlestatus = async (newStatus) => {
  const reqBody = {
    status: newStatus,
    user_id: userSelfData?._id,
    is_status: true,
    isAutomatic: false
  };
  try {
    const response = await ApiService.post(
      API_ENDPOINTS.updateUserDetails,
      reqBody
    );
    if (response?.data && response?.statusCode == 200) {
      let locadata=JSON.parse(localStorage.getItem("userData") || "{}");

      const updatedUserDetails = {
        ...locadata,
        customStatus: "",
        customStatusEmoji: "",status: newStatus
      };
      
      // const updatedUserDetails = { ...userSelfData, status: newStatus };
      localStorage.setItem("userData", JSON.stringify(updatedUserDetails)); // Persist changes
      getUserSelfDetails(updatedUserDetails._id);
    }
  }catch(error){
    handleApiError(error, "Error while updating status");
  }
};


  const profileMenuItems = [
    {
      key: "profileMenuItem-1",
      label: (
        <Flex align="center" gap="small">
          <CustomAvatar img={userSelfData?.thumbnailAvatarUrl} userName={userSelfData?.userName || userSelfData?.username} size={40} />
          <Flex vertical gap="4px">
            <span className="name">{userSelfData?.fullName}</span>
            <span className="username">@{userSelfData?.userName}</span>
          </Flex>
        </Flex>
      ),
      className: "profile-menu-dropdown__title",
    },
    { type: "divider" },
    {
      key: "profileMenuItem-2",
      label: (
        <Flex style={{ width: "100%" }} align="center" gap="small">
          {userSelfData?.customStatus ? (
            <div className="customtStatusMainContainier">
              <div className="customStatusImgText" onClick={showSetCustomStatusModal}>
               {userSelfData.customStatusEmoji &&  (
                  <img
                    className="search-icon"
                    width={20}
                    height={20}
                    src={userSelfData.customStatusEmoji}                  />
                )}
                <p>{userSelfData.customStatus}</p>
              </div>
              <Button
                type="text"
                variant="filled"
                onClick={clearCustomStatus}
              >
                <Tooltip title="Clear">
                  <CloseCircleOutlined style={{ fontSize: "18px" }} />
                </Tooltip>
              </Button>
            </div>
          ) : (
            <div onClick={showSetCustomStatusModal} className="customStatusImgText">
              <EmojiIcon /> Set a Custom Status
            </div>
          )}
        </Flex>
      ),
    },
    { type: "divider" },
    {
      key: "profileMenuItem-3",
      label: <UserStatusBadge status="Online" showStatus={true} />,
      onClick: () => handlestatus("online"),
    },
    {
      key: "profileMenuItem-4",
      label: <UserStatusBadge status="away" showStatus={true} />,
      onClick: () => handlestatus("away"),
    },
    {
      key: "profileMenuItem-5",
      label: <UserStatusBadge status="busy" showStatus={true} />,
      className: "ec-dropdown__submenu profile-menu-dropdown__submenu--dnd",
      onClick: () => handlestatus("busy"),
    },
    {
      key: "profileMenuItem-6",
      label: <UserStatusBadge status="do_not_disturb" showStatus={true} />,
      className: "ec-dropdown__submenu profile-menu-dropdown__submenu--dnd",
      onClick: () => handlestatus("do_not_disturb"),
    },
    {
      key: "profileMenuItem-7",
      label: <UserStatusBadge status="offline" showStatus={true} />,
      onClick: () => handlestatus("offline"),
    },
    { type: "divider" },
    {
      key: "profileMenuItem-8",
      label: (
        <Flex align="center" gap="small">
          <i className="fa-regular fa-user"></i>
          Profile
        </Flex>
      ),
      onClick: showProfileModal,
    },
    ...(UserData?.roleName == 'Admin'
      ? [{
          key: "profileMenuItem-9",
          label: (
            <Flex align="center" gap="small">
              <i className="fa-regular fa-user"></i>
              Admin Setting
            </Flex>
          ),
          onClick: ()=>{navigate('/admin/company-registartion')},
        }]
      : []),
    { type: "divider" },
  
    {
      key: "profileMenuItem-10",
      label: (
        <div onClick={(e) => e?.stopPropagation()} >
        
        <Flex align="center" gap="small" onClick={() => {
          logOut();
          socket.emit('deregister',UserData?._id)
          socket.emit('logout',UserData?._id)

        }}>          
          <LogoutOutlined />
          Log Out
        </Flex>
          </div>
      ),
      // onClick: logOut,
      onClick: ()=>{ logOut();socket.emit('deregister',UserData?._id);
        socket.emit('logout',UserData?._id)

      },
      
    },
  ];

  const mobileDrawerProfileMenuItems = [
    // Similar structure to profileMenuItems, adjusted for mobile drawer
    ...profileMenuItems.slice(0, 12), // Exclude the last item (Log Out)
  {
      key: "mobileDrawerProfileMenuItem-12",
      label: (
        <Flex align="center" gap="middle">
          <i className="fa-solid fa-gear"></i>
          <span>Log Out</span>
        </Flex>
      ),
      onClick: ()=>{ logOut();socket.emit('deregister',UserData?._id)},
    },
  ];

  return (
    <>
      <Flex gap="small" className="menu-controls-lg">
        <div className="profile-menu-dropdown-wrapper">
          <Dropdown
            menu={{ items: profileMenuItems }}
            className="ec-dropdown profile-menu-dropdown"
            dropdownRender={(menu) => (
              <div className="ec-dropdown__menu profile-menu-dropdown__menu">
                {menu}
              </div>
            )}
            trigger={["click"]}
          >
            <Button type="text">
              <div className="avatar-badge-wrapper">
                <CustomAvatar
                  size={28}
                  img={userSelfData?.thumbnailAvatarUrl}
                  userName={userSelfData?.userName}
                />
                <UserStatusBadge
                  status={userSelfData?.status}
                  showStatus={false}
                  font_size={"12px"}
                  badgeBackground={"#FFF"}
                />
              </div>
            </Button>
          </Dropdown>
        </div>
      </Flex>
      <div className="menu-controls-sm">
        <Button type="text" onClick={showProfileSidebarMenu}>
          <i className="fa-solid fa-bars"></i>
        </Button>
        <Drawer
          placement={profileMenuPlacement}
          closable={false}
          onClose={onClose}
          open={openProfileSidebarMenu}
          key={profileMenuPlacement}
          className="mobile-drawer-profile-menu"
          width="auto"
        >
          <Flex vertical className="profile-menu-sidebar">
            <Menu
              onClick={() => setOpenProfileSidebarMenu(false)}
              style={{ width: 256 }}
              items={mobileDrawerProfileMenuItems}
            />
          </Flex>
        </Drawer>
      </div>

      <CustomStatusModal
        userData={userSelfData}
        isSetCustomStatusModalOpen={isSetCustomStatusModalOpen}
        changeCustomStatusModal={handleChangeCustomStatusModal}
        onUserDetailsUpdate={handleUserDetailsUpdate}
      />
    </>
  );
};

export default ProfileMenu;
